import HelpArticleInfoMain from './modules/help/helpArticleInfoMain';
new HelpArticleInfoMain();
